import React, { useEffect, useState, useContext } from "react";
import HeaderDashboard from '../Components/HeaderDashboard'
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../Routes/AuthProvider"
import { GetApprovalRequest } from '../Services/ApprovalAPI';

const TripQueue = () => {
    const { name, userName } = useContext(AuthContext);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        status: "",
    });

    const [approvals, setApprovals] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Convert "dd/mm/yy" or "dd/mm/yyyy" → Date object
    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        handleSearch();
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            //minDate: filters.fromDate,
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);


    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                BookingStatus: filters.status,
                UserName: userName,
                UserType: "Requester"
            };
            const data = await GetApprovalRequest(requestBody);
            const list = data?.allApprovals || [];
            setApprovals(list);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/TripQueue" className="text-muted text-hover-primary">Trip Queue</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div class="row">
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <input
                                type="text"
                                id="fromDate"
                                className="form-control"
                                placeholder="From Date"
                                readOnly
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <input
                                type="text"
                                id="toDate"
                                className="form-control"
                                placeholder="To Date"
                                readOnly
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <div className="form-group">
                                <label className="">Status</label>
                                <select className="form-select form-select-solid"
                                    name="status"
                                    value={filters.status}
                                    onChange={handleChange}
                                >
                                    <option value="ALL">ALL</option>
                                    <option value="Requested">Requested</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Accepted">Accepted</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>

                    </div>
                </div>

                <div className='box_shadow mt-3'>
                    <div class="row">
                        <div class="col-md-12">
                            <h1 className='PendingApproval'>Queue</h1>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr class="fw-bold bg-light">
                                            <th class="ps-4">Sr No</th>
                                            <th>Reference No</th>
                                            <th>Sector</th>
                                            <th>Journey Date</th>
                                            <th>Amount</th>
                                            <th>Requested By</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {approvals.length > 0 ? (
                                            approvals.map((item, index) => (
                                                <tr key={index}>
                                                    <td class="ps-4">{index + 1}</td>
                                                    <td>
                                                        <a
                                                            href={`/dashboard/approval/TripQueueDetail?referenceNo=${item.referenceNo}`}
                                                            className="view_detals"
                                                            title="details"
                                                            style={{ color: "#0d6efd", cursor: "pointer" }}
                                                        >
                                                            {item.referenceNo}
                                                        </a>
                                                    </td>
                                                    <td>{item.origin} - {item.destination}</td>
                                                    <td>
                                                        {new Date(item.departureDate).toLocaleString("en-IN", {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit"
                                                        })}
                                                    </td>
                                                    <td><i className='fa fa-inr'></i> {item.totalFare}</td>
                                                    <td>{item.userId}</td>
                                                    <td className="view_img_icon">
                                                        <>
                                                            {item.level1ApprovalStatus === "Rejected" && (
                                                                <span style={{ color: 'red' }}>
                                                                    {item.level1ApprovalStatus}
                                                                </span>
                                                            )}
                                                            {item.level1ApprovalStatus === "Accepted" && (
                                                                <span style={{ color: 'green' }}>
                                                                    Approved
                                                                </span>
                                                            )}
                                                            {item.level1ApprovalStatus === "Requested" && (
                                                                <span style={{ color: '#dacd65' }}>
                                                                    {item.level1ApprovalStatus}
                                                                </span>
                                                            )}
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="13" className="text-center text-muted">
                                                    {loading ? "Loading..." : "No records found"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
};
export default TripQueue;